import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  fr: {
    nav: { services: "Services", how: "Comment ça marche", zones: "Zones", business: "Business", about: "À propos", help: "Aide", careers: "Carrière", quote: "Devis gratuit" },    cta: { book: "Devis gratuit", myPrice: "Mon devis", continue: "Continuer", back: "Retour", submit: "Envoyer ma demande de devis", noCommitment: "Devis gratuit · sans engagement", whatsapp: "Envoyer des photos sur WhatsApp" },
    hero: {
      title1: "Déménagement, débarras et nettoyage en Suisse romande",
      title1Mobile: "Déménagement, débarras et nettoyage en Suisse romande",
      dropOnMobile: "",
      title2: "",
      sub: "Mopper s'occupe de tout ce qui vous encombre.",
      trust: "Noté 5/5 sur Google",
      highlight: "débarras",
      selectService: "Quel service ?",
      postalCode: "Code postal",
      reassurance: [
        "RC professionnelle",
        "Équipe fiable et équipée",
        "Tri et recyclage responsable",
      ],
      pricingHint: "Devis gratuit en 24h",
      vatIncluded: "Sans engagement",
    },
    services: {
      heading: "Nos services",
      sub: "Un seul interlocuteur pour vider, transporter, ranger, nettoyer et recycler.",
      move: {
        title: "Déménagement",
        desc: "Déménagement complet ou partiel, avec protection, chargement, transport, déchargement et installation de vos meubles.",
        tag: "Particuliers & pros",
        bullets: ["Protection des meubles", "Transport local, national ou international", "Démontage et remontage en option"],
        price: "sur devis",
        cta: "Obtenir un devis",
      },
      clear: {
        title: "Débarras",
        desc: "Nous vidons vos espaces encombrés rapidement, proprement et avec une gestion responsable des objets.",
        tag: "Appartement · cave · garage",
        bullets: ["Cave, grenier, garage, logement", "Tri, évacuation et recyclage", "Nettoyage possible après intervention"],
        price: "sur devis",
        cta: "Demander un débarras",
      },
      declutter: {
        title: "Désencombrement",
        desc: "On vous aide à trier, alléger et reprendre le contrôle de votre intérieur sans tout jeter brutalement.",
        tag: "Accompagnement au tri",
        bullets: ["Tri avec vous", "Garder, donner, recycler ou jeter", "Optimisation de l'espace"],
        price: "sur devis",
        cta: "Désencombrer mon espace",
      },
      organize: {
        title: "Home Organizing",
        desc: "Organisation professionnelle de vos pièces, placards, dressing, cuisine, buanderie ou chambre d'enfant.",
        tag: "Organisation intérieure",
        bullets: ["Rangement esthétique et pratique", "Solutions de rangement", "Système durable au quotidien"],
        price: "sur devis",
        cta: "Organiser mon intérieur",
      },
      clean: {
        title: "Nettoyage",
        desc: "Nettoyage après déménagement, après débarras, avant état des lieux ou pour remettre un espace en ordre.",
        tag: "Remise en état",
        bullets: ["Nettoyage de fin de bail", "Nettoyage après débarras", "Résultat propre et contrôlé"],
        price: "dès 45 CHF/h",
        cta: "Réserver un nettoyage",
      },
      recycle: {
        title: "Recyclage",
        desc: "Nous trions, évacuons et orientons les objets vers le recyclage, le don ou la revalorisation quand c'est possible.",
        tag: "Responsable & durable",
        bullets: ["Tri par matière", "Déchèterie et centres de tri", "Don ou revalorisation possible"],
        price: "inclus sur devis",
        cta: "En savoir plus",
      },
      assembly: {
        title: "Montage de meubles",
        desc: "Montage, démontage et remontage de meubles avant ou après déménagement, livraison ou réorganisation.",
        tag: "Montage & démontage",
        bullets: ["Meubles IKEA et autres marques", "Démontage avant transport", "Remontage après livraison"],
        price: "sur devis",
        cta: "Demander un montage",
      },
      transport: {
        title: "Transport de meubles",
        desc: "Transport de meubles, canapés, lits, armoires ou objets volumineux en Suisse et à l'international.",
        tag: "Suisse & international",
        bullets: ["Transport national", "Transport international sur demande", "Protection et livraison à l'étage possible"],
        price: "sur devis",
        cta: "Demander un transport",
      },
    },
    packs: {
      heading: "Offres Mopper",
      sub: "Des formules combinées pour ne plus rien gérer.",
      move: {
        name: "Mopper Move",
        tag: "Déménagement",
        desc: "L'essentiel pour un déménagement sans accrocs.",
        items: ["Chargement", "Transport", "Déchargement", "Protection de base", "Placement des meubles"],
        cta: "Devis déménagement",
      },
      clear: {
        name: "Mopper Clear",
        tag: "Débarras",
        desc: "On vide, on trie, on évacue. Vous récupérez l'espace.",
        items: ["Vidage de l'espace", "Tri", "Chargement", "Transport", "Recyclage ou déchèterie"],
        cta: "Devis débarras",
      },
      organize: {
        name: "Mopper Organize",
        tag: "Organisation",
        desc: "Désencombrement et home organizing au quotidien.",
        items: ["Tri", "Organisation", "Optimisation des rangements", "Mise en place d'un système pratique"],
        cta: "Organiser mon espace",
      },
      clean: {
        name: "Mopper Clean",
        tag: "Nettoyage",
        desc: "Remise en état d'un logement, d'un bureau ou d'un local.",
        items: ["Nettoyage après déménagement", "Nettoyage après débarras", "Nettoyage de fin de bail", "Remise en état"],
        cta: "Devis nettoyage",
      },
      full: {
        name: "Mopper Full",
        tag: "Premium",
        featured: true,
        desc: "L'offre complète. Vous déléguez. On orchestre tout.",
        items: ["Déménagement", "Débarras", "Désencombrement", "Nettoyage", "Montage", "Recyclage"],
        cta: "Déléguer tout à Mopper",
      },
    },
    howItWorks: {
      heading: "Comment ça marche ?",
      sub: "Vous savez ce que vous payez, qui vient et avec quoi, avant de vous engager.",
      badge: "Comment ça se passe",
      timings: ["Environ 2\u00a0min", "Sous 24\u00a0h", "Le jour J"],
      ctaTitle: "Prêt à nous confier votre projet ?",
      ctaSub: "Un référent Mopper reste à vos côtés du devis jusqu'à la fin de l'intervention.",
      ctaButton: "Recevoir mon devis",
      ctaMicro: "Environ 2\u00a0minutes · Gratuit et sans engagement",
      ctaWhatsapp: "Une question ? WhatsApp",
      ctaTeamLabel: "Équipe locale, joignable 7\u00a0j/7",
      zone: { heading: "Zones d'intervention", sub: "Suisse romande · transport national & international sur demande.", capital: "Capitale" },
      steps: [
        {
          title: "Décrivez votre besoin",
          desc: "Service, adresse, date et quelques photos. Pas besoin de tout mesurer.",
          bullets: ["Demande rapide et guidée", "Quelques photos suffisent", "Tous vos services au même endroit"],
        },
        {
          title: "Vous recevez le devis",
          desc: "Prix fixe et détaillé, équipe et véhicule inclus. Gratuit et sans engagement.",
          bullets: ["Réponse sous 24\u00a0h", "Prix et prestations détaillés", "Devis gratuit, sans engagement"],
        },
        {
          title: "Nous intervenons",
          desc: "Équipe, matériel et protections prévus. Plusieurs services coordonnés par un seul référent.",
          bullets: ["Équipe et matériel adaptés", "Plusieurs services coordonnés", "Suivi simple jusqu'à la fin"],
        },
      ],
      example: {
        badge: "Exemple",
        docLabel: "Devis N° 2026-0142 · 14.06.2026",
        demandLabel: "Votre demande",
        service: "Déménagement · 3,5 pièces",
        route: "Lausanne → Morges · sam. 5 juillet",
        lines: [
          { label: "Équipe", sub: "3 déménageurs", amount: "CHF 680" },
          { label: "Véhicule", sub: "Utilitaire 22 m³", amount: "CHF 320" },
          { label: "Matériel et protections", sub: "Couvertures, sangles, cartons", amount: "CHF 90" },
          { label: "Nettoyage", sub: "Si demandé", amount: "CHF 420" },
        ],
        priceLabel: "Prix fixe",
        priceValue: "CHF 1'510",
        priceNote: "Exemple · votre devis dépend de votre situation",
        referent: "Votre référent : Julie · joignable 7\u00a0j/7",
      },
      form: {
        title: "Votre demande",
        timing: "~ 2\u00a0min",
        serviceLabel: "Service",
        serviceValue: "Déménagement",
        housingLabel: "Logement",
        housingValue: "3,5 pièces",
        dateLabel: "Date souhaitée",
        dateValue: "Samedi 18 juillet",
        photosLabel: "Photos",
        submit: "Envoyer ma demande",
        toastTitle: "Demande envoyée",
        toastSub: "Réponse sous 24\u00a0h",
      },
    },
    advantages: {
      heading: "Des espaces libérés. Une vie plus simple.",
      sub: "Un seul interlocuteur pour vider, déplacer, organiser, nettoyer et recycler vos espaces.",
      cta: "Demander un devis gratuit",
      combinableLabel: "Services combinables",
      combinableExamples: [
        "Déménagement + Nettoyage fin de bail",
        "Débarras + Nettoyage état des lieux",
        "Déménagement + Débarras",
        "Débarras + Transport de meubles",
      ],
      items: [
        { title: "Un seul interlocuteur", desc: "Une équipe, un devis, un suivi. Vous n'avez qu'un seul contact pour tout coordonner." },
        { title: "Services combinables", desc: "Déménagement, débarras, nettoyage et transport de meubles : on orchestre les prestations dont vous avez besoin." },
        { title: "Gain de temps", desc: "Vous déléguez la logistique de A à Z. Nous nous occupons du planning, du véhicule et du matériel." },
        { title: "Tri responsable", desc: "Don, recyclage, revalorisation. Ce qui peut être sauvé l'est, le reste est évacué proprement." },
        { title: "Équipe équipée", desc: "Véhicules, sangles, protections, outils, EPI : on arrive prêts pour intervenir efficacement." },
        { title: "Moins de stress", desc: "Vous expliquez, on exécute. Plus de cartons abandonnés, plus de week-ends gâchés." },
      ],
      beforeAfter: {
        heading: "Du chaos à l'espace clair.",
        sub: "Cave encombrée, déménagement, fin de bail : on transforme l'avant en après.",
        before: { label: "Avant", points: ["Cave encombrée", "Appartement saturé", "Meubles à déplacer", "Fin de bail stressante", "Objets à trier", "Pièce difficile à utiliser"] },
        after: { label: "Après Mopper", points: ["Espace vidé", "Objets triés", "Meubles transportés", "Logement nettoyé", "Rangements optimisés", "Espace prêt à vivre"] },
      },
      compare: {
        heading: "Le résultat parle de lui-même.",
        sub: "Du chaos à l'espace clair. On orchestre, vous respirez.",
        imgLabel: "Différence visible",
        imgValue: "Avant / après Mopper.",
        beforeTitle: "Avant",
        afterTitle: "Après",
        before: { label: "Sans Mopper", points: ["Cave encombrée", "Déménagement stressant", "Tri qui traîne", "Fin de bail compliquée"] },
        after: { label: "Avec Mopper", points: ["Espaces libérés", "Déménagement orchestré", "Tri responsable réalisé", "État des lieux serein"] },
      },
      img: { badge: "Du chaos à l'espace clair", statLabel: "Vider · Transporter · Ranger", statValue: "Un seul interlocuteur." },
      visual: {
        config: {
          service: "Service",
          serviceVal: "Déménagement",
          home: "Logement",
          homeVal: "3,5 pièces",
          date: "Date",
          dateVal: "Sam. 14",
          status: "Demande prête",
        },
        price: {
          label: "Devis prêt",
          serviceVal: "Déménagement",
          line1: "Prix fixe et détaillé",
          line2: "Équipe et véhicule inclus",
          line3: "Sans engagement",
        },
        done: {
          line1: "Date confirmée",
          line2: "Équipe assignée",
          line3: "Intervention planifiée",
          daysShort: ["L", "M", "M", "J", "V", "S", "D"],
        },
      },
    },
    suiviRc: {
      badge: "Le suivi Mopper",
      heading: "Votre intervention, toujours à portée de main.",
      sub: "Dès l'acceptation de votre devis, vous recevez un lien personnel pour suivre votre intervention étape par étape. Aucun compte à créer\u00a0: toutes les informations importantes restent accessibles directement depuis votre téléphone.",
      subMobile: "Un lien personnel pour suivre votre intervention, sans créer de compte.",
      benefits: [
        "Aucun compte à créer",
        "Avancement actualisé par notre équipe",
        "Toutes les informations au même endroit",
      ],
      cta: "Demander un devis",
      preview: {
        greeting: "Bonjour Camille",
        subtitle: "Suivi de votre déménagement",
        service: "Déménagement",
        date: "Samedi 18 juillet · 09:00",
        team: "Votre équipe Mopper",
        currentStatus: "Nous sommes arrivés",
        lastUpdate: "Dernière mise à jour\u00a0: il y a quelques minutes",
        stepsLabel: "Progression",
        steps: [
          { key: "planned", label: "Intervention confirmée", state: "done" },
          { key: "team_preparing", label: "Notre équipe se prépare", state: "done" },
          { key: "team_en_route", label: "Nous sommes en route", state: "done" },
          { key: "arrived_onsite", label: "Nous sommes arrivés", state: "current" },
          { key: "completed", label: "Intervention terminée", state: "upcoming" },
        ],
        helpLabel: "Besoin d'aide\u00a0? Contactez-nous",
        demoNotice: "Aperçu à titre indicatif · données fictives",
      },
      rc: {
        badge: "Intervention assurée",
        heading: "Votre logement et vos biens sont protégés.",
        sub: "Les interventions Mopper sont couvertes par une assurance responsabilité civile professionnelle. Nous travaillons avec les protections et le matériel adaptés afin de limiter les risques pendant chaque prestation.",
        bullets: [
          "RC professionnelle",
          "Protections adaptées à l'intervention",
          "Équipe et matériel préparés en amont",
        ],
        coverageLabelTemplate: "RC professionnelle jusqu'à CHF\u00a0{amount}\u00a0millions",
      },
    },
    socialProof: {
      heading: "Plus de 500 entreprises et particuliers nous font confiance",
      sub: "Avis vérifiés, clients réels.",
      badge: "Note moyenne 5/5",
      testimonials: [
        { name: "Claire R.", role: "Lausanne · déménagement + nettoyage", text: "J'ai déménagé sans lever le petit doigt. Ils ont tout emballé, transporté, monté, et nettoyé l'ancien appart. Magique." },
        { name: "Julien B.", role: "Genève · débarras de cave", text: "Une cave saturée vidée en une journée, avec tri et recyclage. Aucun stress, équipe pro." },
        { name: "Sarah M.", role: "Morges · nettoyage fin de bail", text: "Appartement rendu impeccable, caution récupérée sans la moindre remarque. Équipe ponctuelle et soignée." },
      ],
    },
    faqShort: {
      heading: "Questions fréquentes",
      sub: "Tout ce qu'il faut savoir avant de demander un devis.",
      items: [
        { q: "Quels services propose Mopper ?", a: "Déménagement, débarras, nettoyage fin de bail et transport de meubles, en Suisse romande." },
        { q: "Est-ce que je peux combiner plusieurs services ?", a: "Oui, c'est même notre force. Déménagement + nettoyage, débarras + recyclage, etc. Tout est combinable dans un même devis." },
        { q: "Comment obtenir un devis ?", a: "Via le formulaire de devis en 2 minutes. Vous pouvez aussi nous envoyer des photos sur WhatsApp pour accélérer." },
        { q: "Intervenez-vous pour les entreprises ?", a: "Oui, particuliers et professionnels. Bureaux, locaux commerciaux, restaurants, cabinets." },
        { q: "Quelles zones couvrez-vous ?", a: "Toute la Suisse romande (VD, GE, FR, NE, JU, VS). Transport national et international de meubles sur demande." },
      ],
      cta: "Voir toutes les questions",
    },
    ctaFinal: {
      heading: "Vous n'avez rien à gérer.",
      heading2: "Mopper s'occupe de tout.",
      reassure: "Devis gratuit sous 24h · Sans engagement · Intervention rapide",
      primary: "Demander un devis gratuit",
      secondary: "Envoyer mes photos sur WhatsApp",
    },
    team: {
      badge: "L'humain d'abord",
      heading: "Des équipes formées.",
      heading2: "Des biens protégés. Des lieux respectés.",
      sub: "Protection des biens, respect des lieux, matériel adapté et suivi humain — du premier carton au dernier coup de propre.",
      trust: [
        { label: "Équipe interne, pas de sous-traitance" },
        { label: "Protections sols, parois, meubles" },
        { label: "Un référent joignable à chaque étape" },
      ],
      items: [
        { title: "Équipe formée", desc: "Manutention, protection, méthodes : nos intervenants sont formés pour chaque type d'intervention, du déménagement au nettoyage fin de bail." },
        { title: "Matériel adapté", desc: "Véhicules, sangles, couvertures, diables, outils, EPI. On arrive avec tout le nécessaire pour intervenir vite et bien." },
        { title: "Protection des biens", desc: "Vos meubles et objets fragiles sont protégés, emballés et manipulés avec soin — et chaque intervention est couverte par notre RC professionnelle." },
        { title: "Tri responsable", desc: "Don, recyclage, revalorisation : on privilégie toujours la deuxième vie à la déchèterie quand c'est possible." },
        { title: "Suivi humain", desc: "Un référent Mopper joignable, des points réguliers, un vrai dialogue. Vous savez où on en est, en temps réel." },
        { title: "Respect des lieux", desc: "Protections au sol, parois protégées, propreté à la sortie. On laisse l'espace comme on aimerait le trouver." },
      ],
    },
    footer: {
      tagline: "Déménagement, débarras et nettoyage en Suisse. Mopper s'occupe de tout ce qui vous encombre.",
      col1: "Entreprise",
      col2: "Ressources",
      col3: "Contact",
      rights: "© 2026 Mopper. Tous droits réservés.",
    },
    booking: {
      progress: "Étape",
      steps: ["Service", "Détails", "Contact", "Récapitulatif"],
      stepService: {
        heading: "Quel service souhaitez-vous ?",
        sub: "Sélectionnez un ou plusieurs services. Vous pouvez tout combiner dans un même devis.",
        options: {
          move: "Déménagement",
          clear: "Débarras",
          declutter: "Désencombrement",
          organize: "Home Organizing",
          clean: "Nettoyage",
          recycle: "Recyclage",
          assembly: "Montage de meubles",
          transport: "Transport de meubles",
          full: "Offre complète",
        },
      },
      stepDetails: {
        heading: "Détails de votre demande",
        message: "Décrivez votre besoin",
        messagePh: "Type d'espace, volume estimé, contraintes (étages, ascenseur), photos sur WhatsApp possible…",
        addressFrom: "Adresse de départ",
        addressTo: "Adresse d'arrivée",
        address: "Adresse d'intervention",
        date: "Date souhaitée",
        rooms: "Nombre de pièces",
        volume: "Volume estimé (m³)",
        floorFrom: "Étage départ",
        floorTo: "Étage arrivée",
        floor: "Étage",
        liftFrom: "Ascenseur départ",
        liftTo: "Ascenseur arrivée",
        lift: "Ascenseur",
        spaceType: "Type d'espace",
        heavyItems: "Objets lourds (piano, coffre…)",
        cleanAfter: "Nettoyage après débarras",
        boxes: "Besoin de cartons",
        disassembly: "Démontage / remontage",
        finalCleaning: "Nettoyage de fin de bail",
        cleanType: "Type de nettoyage",
        surface: "Surface (m²)",
        windows: "Vitres incluses",
        appliances: "Électroménager inclus",
        itemDescription: "Objet à transporter",
        dimensions: "Dimensions approximatives",
        yes: "Oui",
        no: "Non",
      },
      step1: { heading: "Quel type de local souhaitez-vous faire nettoyer ?", options: { bureau: "Bureau", commerce: "Commerce", restaurant: "Restaurant", cabinet: "Cabinet", fitness: "Fitness" } },
      step1Home: { heading: "Quel type de logement ?", options: { appartement: "Appartement", maison: "Maison", studio: "Studio" } },
      stepSize: { heading: "Quelle est la taille du logement ?", hint: "Nos équipes interviennent à plusieurs selon la taille." },
      step2: { heading: "Combien d'heures par passage ?", hint: "Minimum 2h par intervention." },
      step3: { heading: "À quelle fréquence ?", options: { une_fois: "Une fois", hebdomadaire: "Hebdomadaire", bi_hebdo: "Toutes les 2 semaines", mensuel: "Toutes les 4 semaines", plus_souvent: "Plus souvent" } },
      step4: { heading: "Ajouter des options", hint: "Chaque option ajoute automatiquement du temps." },
      step5: { heading: "Votre devis", totalTime: "Temps total", perPass: "Prix par passage", monthly: "Estimation mensuelle", ht: "Prix HT", ttc: "Prix TTC", vat: "TVA 8.1%", hourly: "Tarif horaire TTC" },
      step6: {
        heading: "Vos coordonnées",
        name: "Nom complet", email: "Email", phone: "Téléphone", address: "Adresse d'intervention", postal: "Code postal", date: "Date souhaitée", notes: "Notes (optionnel)",
      },
      summary: {
        heading: "Récapitulatif de votre demande",
        service: "Service(s) demandé(s)",
        details: "Détails",
        contact: "Contact",
        send: "Envoyer ma demande de devis",
        sending: "Envoi en cours…",
      },
      thankYou: { heading: "Merci ! Votre demande est enregistrée.", body: "Un email de confirmation vient de vous être envoyé. Nous revenons vers vous avec un devis sous 24h." },
    },
    about: {
      heading: "À propos de Mopper",
      sub: "Mopper est une entreprise suisse multiservices née d'une idée simple : simplifier les moments compliqués de la vie.",
      intro: "Déménagement, débarras, nettoyage fin de bail ou transport de meubles : nous aidons les particuliers et les professionnels à retrouver des espaces clairs, propres et fonctionnels.",
      sections: [
        { title: "Notre mission", body: "Libérer les particuliers et les professionnels de la charge mentale liée aux espaces encombrés. Un seul interlocuteur pour vider, transporter, ranger, nettoyer et recycler." },
        { title: "Notre méthode", body: "Devis clair, équipe formée, matériel pro, protection des biens, tri responsable. Chaque intervention est cadrée, documentée, et exécutée avec soin." },
        { title: "Nos engagements", body: "Transparence des prix, respect des délais, propreté à la sortie, tri responsable des objets et matériaux. On promet ce qu'on tient." },
        { title: "Notre vision écologique", body: "Don, recyclage et revalorisation prioritaires. On évite le tout-déchet en orientant les objets vers les bonnes filières : Emmaüs, déchèteries, revente." },
        { title: "Nos services", body: "Déménagement, débarras, nettoyage fin de bail et transport de meubles en Suisse romande." },
      ],
    },
    help: {
      heading: "Centre d'aide",
      sub: "Les réponses aux questions fréquentes.",
      faq: [
        { q: "Quels services propose Mopper ?", a: "Déménagement, débarras, nettoyage fin de bail et transport de meubles en Suisse romande." },
        { q: "Est-ce que je peux combiner déménagement, débarras et nettoyage ?", a: "Oui, c'est même notre force. Vous décrivez votre situation, on bâtit une offre combinée qui répond à tout." },
        { q: "Comment obtenir un devis ?", a: "Via le formulaire de devis en 2 minutes. Vous pouvez aussi nous envoyer des photos sur WhatsApp pour accélérer l'estimation." },
        { q: "Dois-je envoyer des photos ?", a: "Ce n'est pas obligatoire mais fortement recommandé : ça nous permet d'estimer plus précisément le volume, les accès et le matériel nécessaire." },
        { q: "Intervenez-vous en urgence ?", a: "Oui, sous réserve de disponibilité. Précisez votre urgence dans la demande, on revient sous quelques heures." },
        { q: "Faites-vous le transport international ?", a: "Oui, transport de meubles ou de déménagements vers la France, l'Italie, l'Allemagne et au-delà. Devis sur mesure." },
        { q: "Que faites-vous des objets récupérés ?", a: "Tri responsable : don (Emmaüs, associations), recyclage par matière, revalorisation quand c'est possible. Le tout-déchet est notre dernier recours." },
        { q: "Les frais de déchèterie sont-ils inclus ?", a: "Inclus dans la majorité des cas (selon volume et nature). En cas de dépassement, c'est précisé clairement dans le devis." },
        { q: "Pouvez-vous démonter et remonter mes meubles ?", a: "Oui, montage / démontage / remontage IKEA et autres marques. À ajouter en option lors du devis." },
        { q: "Faites-vous le nettoyage de fin de bail ?", a: "Oui, avec garantie régie. Nettoyage en profondeur et présence à l'état des lieux possible." },
        { q: "Intervenez-vous pour les entreprises ?", a: "Oui, bureaux, locaux commerciaux, restaurants, cabinets. Déménagement, débarras, nettoyage, organisation, montage." },
        { q: "Quelles zones couvrez-vous ?", a: "Toute la Suisse romande (Vaud, Genève, Fribourg, Neuchâtel, Jura, Valais). Transport national et international sur demande." },
        { q: "Comment se passe le paiement ?", a: "Facture après intervention, paiement par virement bancaire ou TWINT. TVA mentionnée explicitement sur le devis." },
        { q: "Je dois vider une cave à Lausanne, vous intervenez ?", a: "Oui, débarras de cave à Lausanne et dans tout le canton de Vaud. Tri responsable, recyclage, évacuation incluse. Devis sous 24h." },
        { q: "Je rends mon appartement, vous pouvez tout gérer ?", a: "Oui, c'est notre spécialité. Débarras des affaires non emportées, nettoyage fin de bail avec garantie état des lieux, présence à l'état des lieux possible. Un seul interlocuteur." },
        { q: "Je dois débarrasser un logement après un décès, comment se passe l'intervention ?", a: "Avec beaucoup de discrétion et de respect. Nous prenons le temps d'identifier objets de valeur et papiers importants avant tout tri. Famille et notaires accompagnés étape par étape." },
        { q: "Je dois transporter un canapé acheté en ligne, vous le faites ?", a: "Oui, transport de meubles à l'unité ou en lot, à Lausanne, Genève et toute la Suisse. Démontage/remontage possible aux deux extrémités." },
        { q: "Mopper monte-t-il les meubles IKEA ?", a: "Oui, montage de tous les meubles IKEA (Pax, Malm, Hemnes, Billy, dressings entiers). Équipe outillée, tarif transparent, intervention rapide à Lausanne et Genève." },
        { q: "Je veux tout déléguer, que dois-je faire ?", a: "Envoyez-nous quelques photos sur WhatsApp (+41 78 232 18 50) ou remplissez le formulaire en ligne. On vous envoie un devis sous 24h, vous validez, on s'occupe de tout." },
      ],
    },
    careers: {
      heading: "Rejoignez Mopper",
      sub: "Rejoignez une entreprise moderne qui simplifie la vie des gens et transforme leurs espaces.",
      cta: "Postuler",
      roles: [
        { title: "Déménageur · manutentionnaire", type: "CDI / CDD · Suisse romande", desc: "Chargement, transport, protection et installation de meubles chez les clients." },
        { title: "Agent·e de débarras", type: "CDI / CDD · Suisse romande", desc: "Vidage, tri, évacuation responsable d'appartements, caves, garages, locaux." },
        { title: "Agent·e de nettoyage", type: "CDI / Temps partiel ou plein", desc: "Nettoyage après déménagement, après débarras, fin de bail. Travail en équipe ou en binôme." },
        { title: "Monteur·euse de meubles", type: "CDI / CDD · Lausanne · Genève", desc: "Montage, démontage, remontage de meubles IKEA et autres marques chez les clients." },
        { title: "Responsable d'équipe", type: "CDI · Suisse romande", desc: "Encadrement opérationnel d'une équipe terrain. Planning, qualité, relation client." },
        { title: "Coordinateur·trice opérationnel·le", type: "CDI · Lausanne", desc: "Gestion des plannings, des devis, des interventions et du suivi clientèle." },
      ],
    },
    admin: {
      login: { heading: "Admin Mopper", label: "Mot de passe", button: "Se connecter", error: "Mot de passe incorrect" },
      dashboard: { heading: "Réservations", empty: "Aucune réservation pour l’instant.", logout: "Déconnexion" },
    },
    auth: {
      header: { login: "Connexion", account: "Mon espace", loginRegister: "Connexion / Inscription" },
      login: {
        badge: "Espace client",
        title: "Pilotez vos ménages depuis votre espace.",
        subTitle: "Historique, factures, planning, modification de réservations — tout en quelques clics.",
        heading: "Bon retour 👋",
        sub: "Connectez-vous à votre espace Mopper.",
        email: "Email",
        emailPh: "vous@entreprise.ch",
        password: "Mot de passe",
        submit: "Se connecter",
        submitting: "Connexion…",
        success: "Connexion réussie",
        error: "Erreur de connexion",
        noAccount: "Pas encore de compte ?",
        register: "Créer un compte",
      },
      register: {
        badge: "Inscription",
        title: "Créez votre espace en 30 secondes.",
        subTitle: "Un seul compte pour gérer vos réservations, factures et plannings.",
        bullets: ["Sans engagement", "Vos données stockées en Suisse", "Annulation à tout moment"],
        heading: "Créer un compte",
        sub: "Rejoignez plus de 500 clients actifs.",
        name: "Nom complet",
        namePh: "Votre nom",
        email: "Email",
        emailPh: "vous@entreprise.ch",
        phone: "Téléphone (optionnel)",
        phonePh: "+41 79 000 00 00",
        password: "Mot de passe",
        passwordPh: "Minimum 8 caractères",
        submit: "Créer mon compte",
        submitting: "Création…",
        success: "Compte créé. Bienvenue !",
        error: "Erreur lors de l'inscription",
        pwdShort: "Le mot de passe doit contenir au moins 8 caractères.",
        haveAccount: "Déjà un compte ?",
        login: "Se connecter",
      },
      espace: {
        badge: "Espace client",
        greeting: "Bonjour",
        sub: "Pilotez vos prochaines interventions, consultez votre historique et mettez à jour votre profil.",
        newBooking: "Nouvelle réservation",
        logout: "Déconnexion",
        logoutSuccess: "À bientôt !",
        tabBookings: "Mes réservations",
        tabProfile: "Mon profil",
        upcoming: "À venir",
        past: "Historique",
        loading: "Chargement…",
        noUpcoming: "Aucune réservation à venir.",
        noPast: "Aucun historique pour le moment.",
        bookNow: "Réserver maintenant",
        cancel: "Annuler",
        cancelConfirm: "Annuler définitivement cette réservation ?",
        cancelSuccess: "Réservation annulée",
        cancelError: "Impossible d'annuler",
        pricePerVisit: "Prix par passage",
        profileTitle: "Mon profil",
        profileSub: "Ces informations seront utilisées pour pré-remplir vos prochaines réservations.",
        profileEmail: "Email",
        profileName: "Nom complet",
        profilePhone: "Téléphone",
        profilePostal: "Code postal",
        profileAddress: "Adresse",
        save: "Enregistrer",
        saving: "Enregistrement…",
        saveSuccess: "Profil mis à jour",
        saveError: "Erreur lors de la mise à jour",
        status: { pending: "En attente", confirmed: "Confirmée", completed: "Terminée", cancelled: "Annulée" },
        frequency: { une_fois: "Une fois", hebdomadaire: "Chaque semaine", bi_hebdo: "Toutes les 2 semaines", mensuel: "Toutes les 4 semaines", plus_souvent: "Plus souvent" },
        reviewing: "À l'étude",
        quoted: "Devis envoyé",
        quoteIn24h: "Devis sous 24h",
        quoteRef: "DEVIS",
        particular: "Particulier",
        professional: "Professionnel",
        serviceLabels: { move: "Déménagement", transport: "Transport de meubles", clear: "Débarras", declutter: "Désencombrement", organize: "Home Organizing", clean: "Nettoyage", recycle: "Recyclage", assembly: "Montage de meubles", full: "Offre complète" },
      },
    },
  },
  de: {
    nav: { services: "Leistungen", how: "Ablauf", zones: "Gebiete", business: "Business", about: "Über uns", help: "Hilfe", careers: "Karriere", quote: "Gratis-Angebot" },
    cta: { book: "Gratis-Angebot", myPrice: "Mein Angebot", continue: "Weiter", back: "Zurück", submit: "Anfrage senden", noCommitment: "Gratis-Angebot · unverbindlich", whatsapp: "Fotos per WhatsApp senden" },
    hero: {
      title1: "Umzug, Entrümpelung und Reinigung.",
      title1Mobile: "Umzug, Entrümpelung und Reinigung.",
      dropOnMobile: "",
      title2: "",
      sub: "Mopper kümmert sich um alles, was Sie überfordert.",
      trust: "Mit 5/5 auf Google bewertet",
      highlight: "Entrümpelung",
      selectService: "Welche Leistung?",
      postalCode: "PLZ",
      reassurance: ["Berufshaftpflicht (RC)", "Verlässliches und ausgerüstetes Team", "Verantwortliche Sortierung und Recycling"],
      pricingHint: "Gratis-Angebot in 24h",
      vatIncluded: "Unverbindlich",
    },
    services: {
      heading: "Unsere Leistungen",
      sub: "Eine einzige Anlaufstelle: räumen, transportieren, ordnen, reinigen, recyceln.",
      move: { title: "Umzug", desc: "Vollständiger oder teilweiser Umzug mit Schutz, Beladung, Transport, Entladung und Aufbau Ihrer Möbel.", tag: "Privat & Geschäft", bullets: ["Möbelschutz", "Lokal, national, international", "Demontage/Montage optional"], price: "auf Anfrage", cta: "Angebot anfordern" },
      clear: { title: "Entrümpelung", desc: "Wir leeren Ihre überfüllten Räume schnell, sauber und mit verantwortungsvollem Umgang mit den Objekten.", tag: "Wohnung · Keller · Garage", bullets: ["Keller, Estrich, Garage, Wohnung", "Sortierung, Entsorgung, Recycling", "Reinigung danach möglich"], price: "auf Anfrage", cta: "Entrümpelung anfragen" },
      declutter: { title: "Aussortieren", desc: "Wir helfen Ihnen, zu sortieren, zu entlasten und Ihr Zuhause wieder im Griff zu haben — ohne alles wegzuwerfen.", tag: "Begleitete Sortierung", bullets: ["Gemeinsame Sortierung", "Behalten, spenden, recyceln, entsorgen", "Raumoptimierung"], price: "auf Anfrage", cta: "Aussortieren" },
      organize: { title: "Home Organizing", desc: "Professionelle Organisation Ihrer Räume, Schränke, Ankleiden, Küchen, Waschräume oder Kinderzimmer.", tag: "Innere Ordnung", bullets: ["Ästhetisch und praktisch", "Aufbewahrungslösungen", "Nachhaltiges System"], price: "auf Anfrage", cta: "Räume organisieren" },
      clean: { title: "Reinigung", desc: "Reinigung nach Umzug, nach Entrümpelung, vor Abnahme oder zur Wiederherstellung eines Raums.", tag: "Wiederherstellung", bullets: ["Endreinigung", "Reinigung nach Entrümpelung", "Saubere, kontrollierte Ergebnisse"], price: "ab 45 CHF/h", cta: "Reinigung buchen" },
      recycle: { title: "Recycling", desc: "Wir sortieren, entsorgen und führen Objekte dem Recycling, der Spende oder der Aufwertung zu, wenn möglich.", tag: "Verantwortlich & nachhaltig", bullets: ["Sortierung nach Material", "Deponie und Sortierzentren", "Spende oder Aufwertung"], price: "im Angebot enthalten", cta: "Mehr erfahren" },
      assembly: { title: "Möbelmontage", desc: "Montage, Demontage und Wiedermontage von Möbeln vor oder nach Umzug, Lieferung oder Umgestaltung.", tag: "Montage & Demontage", bullets: ["IKEA und andere Marken", "Demontage vor Transport", "Wiedermontage nach Lieferung"], price: "auf Anfrage", cta: "Montage anfragen" },
      transport: { title: "Möbeltransport", desc: "Transport von Möbeln, Sofas, Betten, Schränken oder sperrigen Objekten in der Schweiz und international.", tag: "Schweiz & international", bullets: ["Nationaler Transport", "Internationaler Transport auf Anfrage", "Schutz und Etagenlieferung"], price: "auf Anfrage", cta: "Transport anfragen" },
    },
    packs: {
      heading: "Mopper-Angebote",
      sub: "Kombi-Angebote, damit Sie sich um nichts mehr kümmern müssen.",
      move: { name: "Mopper Move", tag: "Umzug", desc: "Das Wesentliche für einen Umzug ohne Hindernisse.", items: ["Beladung", "Transport", "Entladung", "Basisschutz", "Möbelplatzierung"], cta: "Umzug anfragen" },
      clear: { name: "Mopper Clear", tag: "Entrümpelung", desc: "Wir räumen, sortieren, entsorgen. Sie gewinnen Platz.", items: ["Raum leeren", "Sortierung", "Beladung", "Transport", "Recycling oder Deponie"], cta: "Entrümpelung anfragen" },
      organize: { name: "Mopper Organize", tag: "Organisation", desc: "Aussortieren und Home Organizing im Alltag.", items: ["Sortierung", "Organisation", "Aufbewahrungsoptimierung", "Nachhaltiges System"], cta: "Räume organisieren" },
      clean: { name: "Mopper Clean", tag: "Reinigung", desc: "Wiederherstellung einer Wohnung, eines Büros oder Lokals.", items: ["Reinigung nach Umzug", "Reinigung nach Entrümpelung", "Endreinigung", "Wiederherstellung"], cta: "Reinigung anfragen" },
      full: { name: "Mopper Full", tag: "Premium", featured: true, desc: "Das Komplettangebot. Sie delegieren. Wir orchestrieren.", items: ["Umzug", "Entrümpelung", "Aussortieren", "Reinigung", "Montage", "Recycling"], cta: "Alles an Mopper delegieren" },
    },
    howItWorks: {
      heading: "Sehen Sie genau, was Sie erwartet",
      sub: "Sie wissen, was Sie zahlen, wer kommt und womit – bevor Sie sich festlegen.",
      badge: "So läuft es ab",
      timings: ["Rund 2\u00a0Min.", "Innert 24\u00a0h", "Am Einsatztag"],
      ctaTitle: "Bereit, uns Ihr Projekt anzuvertrauen?",
      ctaSub: "Ein Mopper-Ansprechpartner begleitet Sie vom Angebot bis zum Einsatzende.",
      ctaButton: "Angebot erhalten",
      ctaMicro: "Rund 2\u00a0Minuten · Gratis und unverbindlich",
      ctaWhatsapp: "Eine Frage? WhatsApp",
      ctaTeamLabel: "Lokales Team, an 7\u00a0Tagen pro Woche erreichbar",
      zone: { heading: "Einsatzgebiete", sub: "Westschweiz · nationaler und internationaler Transport auf Anfrage.", capital: "Hauptort" },
      steps: [
        {
          title: "Sie beschreiben Ihren Bedarf",
          desc: "Leistung, Adresse, Datum und ein paar Fotos. Kein Ausmessen nötig.",
          bullets: ["Schnelle, geführte Anfrage", "Ein paar Fotos genügen", "Alle Ihre Leistungen an einem Ort"],
        },
        {
          title: "Sie erhalten das Angebot",
          desc: "Festpreis und detailliert, Team und Fahrzeug inklusive. Gratis und unverbindlich.",
          bullets: ["Antwort innert 24\u00a0h", "Preis und Leistungen im Detail", "Kostenlos und unverbindlich"],
        },
        {
          title: "Wir übernehmen den Einsatz",
          desc: "Team, Material und Schutz sind vorbereitet. Mehrere Leistungen, ein Ansprechpartner.",
          bullets: ["Passendes Team und Material", "Mehrere Leistungen koordiniert", "Einfache Begleitung bis zum Schluss"],
        },
      ],
      example: {
        badge: "Beispiel",
        docLabel: "Angebot Nr. 2026-0142 · 14.06.2026",
        demandLabel: "Ihre Anfrage",
        service: "Umzug · 3,5 Zimmer",
        route: "Lausanne → Morges · Sa. 5. Juli",
        lines: [
          { label: "Team", sub: "3 Umzugsprofis", amount: "CHF 680" },
          { label: "Fahrzeug", sub: "Transporter 22 m³", amount: "CHF 320" },
          { label: "Material und Schutz", sub: "Decken, Gurte, Kartons", amount: "CHF 90" },
          { label: "Reinigung", sub: "Auf Wunsch", amount: "CHF 420" },
        ],
        priceLabel: "Festpreis",
        priceValue: "CHF 1'510",
        priceNote: "Beispiel · Ihr Angebot hängt von Ihrer Situation ab",
        referent: "Ihr Ansprechpartner: Julie · 7\u00a0Tage erreichbar",
      },
      form: {
        title: "Ihre Anfrage",
        timing: "~ 2\u00a0Min.",
        serviceLabel: "Leistung",
        serviceValue: "Umzug",
        housingLabel: "Wohnung",
        housingValue: "3,5 Zimmer",
        dateLabel: "Wunschtermin",
        dateValue: "Samstag, 18. Juli",
        photosLabel: "Fotos",
        submit: "Anfrage senden",
        toastTitle: "Anfrage gesendet",
        toastSub: "Antwort innert 24\u00a0h",
      },
    },
    advantages: {
      heading: "Freie Räume. Einfacheres Leben.",
      sub: "Ein einziger Ansprechpartner zum Leeren, Transportieren, Organisieren, Reinigen und Recyceln Ihrer Räume.",
      cta: "Gratis-Angebot anfragen",
      combinableLabel: "Kombinierbare Services",
      combinableExamples: [
        "Umzug + Endreinigung",
        "Entrümpelung + Endreinigung",
        "Umzug + Entrümpelung",
        "Entrümpelung + Möbeltransport",
      ],
      items: [
        { title: "Ein einziger Ansprechpartner", desc: "Ein Team, ein Angebot, eine Begleitung. Sie haben nur einen Kontakt für alles." },
        { title: "Kombinierbare Leistungen", desc: "Umzug, Entrümpelung, Reinigung und Möbeltransport: wir orchestrieren, was Sie wirklich brauchen." },
        { title: "Zeitgewinn", desc: "Sie delegieren die Logistik von A bis Z. Wir kümmern uns um Planung, Fahrzeug und Material." },
        { title: "Verantwortliche Sortierung", desc: "Spende, Recycling, Aufwertung. Was gerettet werden kann, wird gerettet — der Rest wird sauber entsorgt." },
        { title: "Ausgerüstetes Team", desc: "Fahrzeuge, Gurte, Schutz, Werkzeuge, PSA: wir kommen vorbereitet und arbeiten effizient." },
        { title: "Weniger Stress", desc: "Sie erklären, wir setzen um. Keine zurückgelassenen Kartons, keine verlorenen Wochenenden mehr." },
      ],
      compare: {
        heading: "Das Ergebnis spricht für sich.",
        sub: "Vom Chaos zum klaren Raum. Wir orchestrieren, Sie atmen durch.",
        imgLabel: "Sichtbarer Unterschied",
        imgValue: "Vorher / Nachher Mopper.",
        beforeTitle: "Vorher",
        afterTitle: "Nachher",
        before: { label: "Ohne Mopper", points: ["Überfüllter Keller", "Stressiger Umzug", "Sortierung bleibt liegen", "Komplizierte Übergabe"] },
        after: { label: "Mit Mopper", points: ["Befreite Räume", "Geordneter Umzug", "Verantwortliche Sortierung", "Entspannte Übergabe"] },
      },
      img: { badge: "Vom Chaos zum klaren Raum", statLabel: "Leeren · Transportieren · Ordnen", statValue: "Ein einziger Ansprechpartner." },
      visual: {
        config: {
          service: "Service",
          serviceVal: "Umzug",
          home: "Wohnung",
          homeVal: "3,5 Zimmer",
          date: "Datum",
          dateVal: "Sa. 14",
          status: "Anfrage bereit",
        },
        price: {
          label: "Angebot bereit",
          serviceVal: "Umzug",
          line1: "Fester und detaillierter Preis",
          line2: "Team und Fahrzeug inklusive",
          line3: "Unverbindlich",
        },
        done: {
          line1: "Datum bestätigt",
          line2: "Team zugewiesen",
          line3: "Einsatz geplant",
          daysShort: ["M", "D", "M", "D", "F", "S", "S"],
        },
      },
    },
    suiviRc: {
      badge: "Mopper-Auftragsverfolgung",
      heading: "Ihr Einsatz, jederzeit griffbereit.",
      sub: "Sobald Ihr Angebot bestätigt ist, erhalten Sie einen persönlichen Link, um Ihren Einsatz Schritt für Schritt mitzuverfolgen. Kein Konto nötig — alle wichtigen Informationen bleiben direkt auf Ihrem Handy verfügbar.",
      subMobile: "Ein persönlicher Link, um Ihren Einsatz zu verfolgen – ohne Konto.",
      benefits: [
        "Kein Konto nötig",
        "Fortschritt live von unserem Team aktualisiert",
        "Alle Informationen an einem Ort",
      ],
      cta: "Angebot anfragen",
      preview: {
        greeting: "Guten Tag Camille",
        subtitle: "Verfolgung Ihres Umzugs",
        service: "Umzug",
        date: "Samstag, 18. Juli · 09:00",
        team: "Ihr Mopper-Team",
        currentStatus: "Wir sind angekommen",
        lastUpdate: "Letzte Aktualisierung\u00a0: vor wenigen Minuten",
        stepsLabel: "Fortschritt",
        steps: [
          { key: "planned", label: "Einsatz bestätigt", state: "done" },
          { key: "team_preparing", label: "Unser Team bereitet sich vor", state: "done" },
          { key: "team_en_route", label: "Wir sind unterwegs", state: "done" },
          { key: "arrived_onsite", label: "Wir sind angekommen", state: "current" },
          { key: "completed", label: "Einsatz abgeschlossen", state: "upcoming" },
        ],
        helpLabel: "Brauchen Sie Hilfe\u00a0? Kontaktieren Sie uns",
        demoNotice: "Beispielansicht · fiktive Daten",
      },
      rc: {
        badge: "Einsatz versichert",
        heading: "Ihre Wohnung und Ihre Sachen sind geschützt.",
        sub: "Die Mopper-Einsätze sind durch eine Berufshaftpflichtversicherung gedeckt. Wir arbeiten mit den passenden Schutzmaterialien und der geeigneten Ausrüstung, um Risiken während jedes Einsatzes zu begrenzen.",
        bullets: [
          "Berufshaftpflichtversicherung",
          "Auf den Einsatz abgestimmter Schutz",
          "Team und Material im Voraus vorbereitet",
        ],
        coverageLabelTemplate: "Berufshaftpflicht bis zu CHF\u00a0{amount}\u00a0Millionen",
      },
    },
    _purged_DE_block: {
      _hero: null, _services: null, _features: null, _howItWorks: null, _oldAdvantages: null,
      _note: "Anciens blocs DE (nettoyage uniquement) supprimés lors de la migration multiservices."
    },
    socialProof: {
      heading: "Mehr als 500 Unternehmen vertrauen uns",
      sub: "Verifizierte Bewertungen, echte Kunden.",
      badge: "Durchschnitt 4.9/5 aus 1'284 Bewertungen",
      testimonials: [
        { name: "Claire R.", role: "Office Managerin, Lausanne", text: "Seit wir mit Mopper arbeiten, denke ich nicht mehr ans Putzen. Montags ist alles makellos." },
        { name: "Julien B.", role: "Restaurantbesitzer, Genf", text: "Pünktliches Team, schonende Produkte, einfache Abrechnung. Klare Empfehlung." },
        { name: "Sarah M.", role: "Leitung Arztpraxis", text: "Eine feste Person, die unser Haus kennt. Diese Konstanz macht den Unterschied." },
      ],
    },
    faqShort: {
      heading: "Häufige Fragen",
      sub: "Alles, was Sie vor der Buchung wissen müssen.",
      items: [
        { q: "Wie funktioniert die Buchung ?", a: "In 2 Minuten: Leistung, Frequenz und Optionen wählen, bestätigen. Wir melden uns innert 24h." },
        { q: "Kann ich die Stunden anpassen ?", a: "Ja, jederzeit. Keine Mindestlaufzeit." },
        { q: "Wer kommt zu mir ?", a: "Ein fester, geschulter und geprüfter Ansprechpartner." },
        { q: "Verwenden Sie aggressive Produkte ?", a: "Nein. Wir setzen auf umweltfreundliche Profi-Produkte und bieten Dampfreinigung an." },
        { q: "Kann ich ein Angebot anfragen ?", a: "Ja, direkt über den Konfigurator oder per Kontakt." },
      ],
      cta: "Alle Fragen anzeigen",
    },
    ctaFinal: {
      heading: "Sie müssen sich um nichts kümmern.",
      heading2: "Mopper übernimmt alles.",
      reassure: "Gratis-Angebot in 24h · Unverbindlich · Schneller Einsatz",
      primary: "Gratis-Angebot anfragen",
      secondary: "Fotos per WhatsApp senden",
    },
    team: {
      badge: "Mensch zuerst",
      heading: "Geschulte Teams.",
      heading2: "Geschützte Güter. Respektierte Räume.",
      sub: "Schutz Ihrer Güter, Respekt vor Ihren Räumen, passendes Material und menschliche Begleitung — vom ersten Karton bis zum letzten Wischen.",
      trust: [
        { label: "Internes Team, keine Subunternehmen" },
        { label: "Boden-, Wand- und Möbelschutz" },
        { label: "Ansprechperson in jeder Phase erreichbar" },
      ],
      items: [
        { title: "Geschultes Team", desc: "Handhabung, Schutz, Methoden: unsere Einsatzkräfte sind für jeden Einsatztyp ausgebildet — vom Umzug bis zur Endreinigung." },
        { title: "Passendes Material", desc: "Fahrzeuge, Gurte, Decken, Sackkarren, Werkzeuge, PSA. Wir kommen mit allem Nötigen, um schnell und gut zu arbeiten." },
        { title: "Schutz Ihrer Güter", desc: "Ihre Möbel und empfindlichen Gegenstände werden geschützt, verpackt und sorgfältig behandelt — und jeder Einsatz ist durch unsere Berufshaftpflicht (RC) gedeckt." },
        { title: "Verantwortliche Sortierung", desc: "Spende, Recycling, Aufwertung: wir bevorzugen die zweite Verwendung gegenüber der Deponie, wann immer möglich." },
        { title: "Menschliche Begleitung", desc: "Eine erreichbare Mopper-Bezugsperson, regelmässige Updates, echter Dialog. Sie wissen jederzeit, wo wir stehen." },
        { title: "Respekt vor Räumen", desc: "Bodenschutz, Wandschutz, Sauberkeit beim Verlassen. Wir hinterlassen den Raum so, wie wir ihn gerne vorfinden würden." },
      ],
    },
    footer: {
      tagline: "Umzug, Entrümpelung und Reinigung in der Schweiz. Mopper kümmert sich um alles, was Sie überfordert.",
      col1: "Unternehmen",
      col2: "Ressourcen",
      col3: "Kontakt",
      rights: "© 2026 Mopper. Alle Rechte vorbehalten.",
    },
    booking: {
      progress: "Schritt",
      steps: ["Leistung", "Details", "Kontakt", "Übersicht"],
      stepService: {
        heading: "Welche Leistung wünschen Sie?",
        sub: "Wählen Sie eine oder mehrere Leistungen. Alles ist in einem Angebot kombinierbar.",
        options: { move: "Umzug", clear: "Entrümpelung", declutter: "Aussortieren", organize: "Home Organizing", clean: "Reinigung", recycle: "Recycling", assembly: "Möbelmontage", transport: "Möbeltransport", full: "Komplettangebot" },
      },
      stepDetails: {
        heading: "Details Ihrer Anfrage",
        message: "Beschreiben Sie Ihren Bedarf",
        messagePh: "Raumtyp, geschätztes Volumen, Einschränkungen (Etagen, Lift), Fotos via WhatsApp möglich…",
        addressFrom: "Abholadresse", addressTo: "Zieladresse", address: "Einsatzadresse", date: "Wunschdatum",
        rooms: "Anzahl Räume", volume: "Geschätztes Volumen (m³)", floorFrom: "Etage Abholung", floorTo: "Etage Ziel", floor: "Etage",
        liftFrom: "Lift Abholung", liftTo: "Lift Ziel", lift: "Lift", spaceType: "Raumtyp",
        heavyItems: "Schwere Gegenstände (Klavier, Tresor…)", cleanAfter: "Reinigung nach Entrümpelung",
        boxes: "Kartonbedarf", disassembly: "Demontage / Montage", finalCleaning: "Endreinigung", cleanType: "Reinigungstyp",
        surface: "Fläche (m²)", windows: "Fenster inkl.", appliances: "Geräte inkl.",
        itemDescription: "Zu transportierender Gegenstand", dimensions: "Ungefähre Masse", yes: "Ja", no: "Nein",
      },
      step1: { heading: "Welche Art von Raum soll gereinigt werden?", options: { bureau: "Büro", commerce: "Geschäft", restaurant: "Restaurant", cabinet: "Praxis", fitness: "Fitness" } },
      step1Home: { heading: "Welche Art von Wohnung?", options: { appartement: "Wohnung", maison: "Haus", studio: "Studio" } },
      stepSize: { heading: "Wie gross ist die Wohnung?", hint: "Je nach Grösse arbeiten wir zu mehreren." },
      step2: { heading: "Wie viele Stunden pro Einsatz?", hint: "Mindestens 2 Stunden pro Einsatz." },
      step3: { heading: "Mit welcher Frequenz?", options: { une_fois: "Einmalig", hebdomadaire: "Wöchentlich", bi_hebdo: "Alle 2 Wochen", mensuel: "Alle 4 Wochen", plus_souvent: "Häufiger" } },
      step4: { heading: "Optionen hinzufügen", hint: "Jede Option fügt automatisch Zeit hinzu." },
      step5: { heading: "Ihr Angebot", totalTime: "Gesamtzeit", perPass: "Preis pro Einsatz", monthly: "Monatsschätzung", ht: "Netto", ttc: "Brutto", vat: "MWST 8.1%", hourly: "Stundentarif brutto" },
      step6: { heading: "Ihre Kontaktdaten", name: "Vollständiger Name", email: "E-Mail", phone: "Telefon", address: "Einsatzadresse", postal: "PLZ", date: "Wunschdatum", notes: "Notizen (optional)" },
      summary: { heading: "Zusammenfassung Ihrer Anfrage", service: "Gewünschte Leistung(en)", details: "Details", contact: "Kontakt", send: "Anfrage senden", sending: "Wird gesendet…" },
      thankYou: { heading: "Danke! Ihre Anfrage ist eingegangen.", body: "Eine Bestätigungsmail wurde versendet. Wir melden uns mit einem Angebot innert 24 Stunden." },
    },
    about: {
      heading: "Über Mopper",
      sub: "Mopper ist ein Schweizer Multi-Service-Unternehmen, geboren aus einer einfachen Idee: die schwierigen Momente des Lebens zu vereinfachen.",
      intro: "Umzug, Entrümpelung, Endreinigung oder Möbeltransport: Wir helfen Privatpersonen und Unternehmen, freie, saubere und funktionale Räume wiederzuerlangen.",
      sections: [
        { title: "Unsere Mission", body: "Privatpersonen und Unternehmen von der mentalen Belastung überfüllter Räume befreien. Ein einziger Ansprechpartner zum Leeren, Transportieren, Ordnen, Reinigen und Recyceln." },
        { title: "Unsere Methode", body: "Klares Angebot, geschultes Team, Profimaterial, Güterschutz, verantwortliche Sortierung. Jeder Einsatz ist strukturiert, dokumentiert und sorgfältig ausgeführt." },
        { title: "Unsere Verpflichtungen", body: "Preistransparenz, Termintreue, Sauberkeit bei der Übergabe, verantwortliche Sortierung von Objekten und Materialien. Wir versprechen nur, was wir halten." },
        { title: "Unsere ökologische Vision", body: "Spende, Recycling und Aufwertung haben Priorität. Wir vermeiden Abfall, indem wir Objekte den richtigen Kanälen zuführen: Emmaüs, Sortierzentren, Wiederverkauf." },
        { title: "Unsere Leistungen", body: "Umzug, Entrümpelung, Endreinigung und Möbeltransport in der Westschweiz." },
      ],
    },
    help: {
      heading: "Hilfezentrum",
      sub: "Antworten auf häufige Fragen.",
      faq: [
        { q: "Welche Leistungen bietet Mopper an?", a: "Umzug, Entrümpelung, Endreinigung und Möbeltransport in der Westschweiz." },
        { q: "Kann ich Umzug, Entrümpelung und Reinigung kombinieren?", a: "Ja, das ist sogar unsere Stärke. Sie beschreiben Ihre Situation, wir erstellen ein Kombiangebot, das alles abdeckt." },
        { q: "Wie bekomme ich ein Angebot?", a: "Über das Angebotsformular in 2 Minuten. Sie können uns auch Fotos via WhatsApp senden, um die Schätzung zu beschleunigen." },
        { q: "Muss ich Fotos senden?", a: "Es ist nicht zwingend, aber sehr empfohlen: So können wir Volumen, Zugang und benötigtes Material genauer einschätzen." },
        { q: "Sind Notfälle möglich?", a: "Ja, vorbehältlich der Verfügbarkeit. Geben Sie die Dringlichkeit in der Anfrage an, wir melden uns innert weniger Stunden." },
        { q: "Bieten Sie internationalen Transport an?", a: "Ja, Möbel- oder Umzugstransport nach Frankreich, Italien, Deutschland und darüber hinaus. Massgeschneidertes Angebot." },
        { q: "Was geschieht mit den abgeholten Objekten?", a: "Verantwortliche Sortierung: Spende (Emmaüs, Vereine), Materialrecycling, Aufwertung wo möglich. Abfall ist die letzte Option." },
        { q: "Sind die Deponiegebühren inbegriffen?", a: "In den meisten Fällen ja (je nach Volumen und Art). Bei Überschreitung wird dies klar im Angebot erwähnt." },
        { q: "Können Sie meine Möbel demontieren und wieder montieren?", a: "Ja, Montage / Demontage / Remontage IKEA und andere Marken. Optional zum Angebot hinzufügbar." },
        { q: "Bieten Sie Endreinigungen an?", a: "Ja, mit Verwaltungsgarantie. Tiefenreinigung und Anwesenheit bei der Wohnungsabnahme möglich." },
        { q: "Arbeiten Sie für Unternehmen?", a: "Ja, Büros, Geschäftsräume, Restaurants, Praxen. Umzug, Entrümpelung, Reinigung, Montage." },
        { q: "Welche Gebiete decken Sie ab?", a: "Die gesamte Westschweiz (Waadt, Genf, Freiburg, Neuenburg, Jura, Wallis). Nationaler und internationaler Transport auf Anfrage." },
        { q: "Wie läuft die Bezahlung ab?", a: "Rechnung nach Einsatz, Zahlung per Banküberweisung oder TWINT. MWST explizit im Angebot ausgewiesen." },
        { q: "Ich muss einen Keller in Lausanne ausräumen, kommen Sie?", a: "Ja, Keller-Entrümpelung in Lausanne und im ganzen Kanton Waadt. Verantwortliche Sortierung, Recycling, Entsorgung inklusive. Angebot innert 24 Stunden." },
        { q: "Ich gebe meine Wohnung ab, können Sie alles übernehmen?", a: "Ja, das ist unsere Spezialität. Entrümpelung des Zurückgebliebenen, Endreinigung mit Wohnungsabnahme-Garantie, Anwesenheit möglich. Ein einziger Ansprechpartner." },
        { q: "Ich muss nach einem Todesfall ausräumen, wie verläuft das?", a: "Mit viel Diskretion und Respekt. Wir nehmen uns Zeit, Wertgegenstände und wichtige Papiere zu identifizieren. Familie und Notare werden Schritt für Schritt begleitet." },
        { q: "Ich muss ein online gekauftes Sofa transportieren, machen Sie das?", a: "Ja, Einzel- oder Mehrfachmöbeltransport in Lausanne, Genf und der ganzen Schweiz. Demontage/Montage an beiden Enden möglich." },
        { q: "Montiert Mopper IKEA-Möbel?", a: "Ja, Montage aller IKEA-Möbel (Pax, Malm, Hemnes, Billy, ganze Ankleiden). Ausgerüstetes Team, transparenter Tarif, schneller Einsatz in Lausanne und Genf." },
        { q: "Ich möchte alles delegieren, was muss ich tun?", a: "Senden Sie uns ein paar Fotos via WhatsApp (+41 78 232 18 50) oder füllen Sie das Online-Formular aus. Wir senden Ihnen ein Angebot innert 24 Stunden, Sie bestätigen, wir kümmern uns um alles." },
      ],
    },
    careers: {
      heading: "Werden Sie Teil von Mopper",
      sub: "Schliessen Sie sich einem modernen Unternehmen an, das das Leben der Menschen vereinfacht und ihre Räume transformiert.",
      cta: "Bewerben",
      roles: [
        { title: "Möbelträger·in · Logistiker·in", type: "Unbefristet / Befristet · Westschweiz", desc: "Beladung, Transport, Schutz und Aufbau von Möbeln bei Kunden." },
        { title: "Entrümpelungs-Mitarbeiter·in", type: "Unbefristet / Befristet · Westschweiz", desc: "Leerung, Sortierung, verantwortliche Entsorgung von Wohnungen, Kellern, Garagen, Lokalen." },
        { title: "Reinigungs-Mitarbeiter·in", type: "Unbefristet / Teil- oder Vollzeit", desc: "Reinigung nach Umzug, nach Entrümpelung, Endreinigung. Arbeit im Team oder zu zweit." },
        { title: "Möbelmonteur·in", type: "Unbefristet / Befristet · Lausanne · Genf", desc: "Montage, Demontage und Remontage von IKEA und anderen Marken bei Kunden." },
        { title: "Team Leader", type: "Unbefristet · Westschweiz", desc: "Operative Leitung eines Einsatzteams. Planung, Qualität, Kundenbeziehung." },
        { title: "Operative·r Koordinator·in", type: "Unbefristet · Lausanne", desc: "Verwaltung von Planungen, Angeboten, Einsätzen und Kundennachverfolgung." },
      ],
    },
    admin: {
      login: { heading: "Mopper Admin", label: "Passwort", button: "Anmelden", error: "Falsches Passwort" },
      dashboard: { heading: "Buchungen", empty: "Noch keine Buchungen.", logout: "Abmelden" },
    },
    auth: {
      header: { login: "Anmelden", account: "Mein Bereich", loginRegister: "Anmelden / Registrieren" },
      login: {
        badge: "Kundenbereich",
        title: "Steuern Sie Ihre Reinigungen aus Ihrem Bereich.",
        subTitle: "Verlauf, Rechnungen, Planung, Anpassung von Buchungen — alles mit wenigen Klicks.",
        heading: "Willkommen zurück 👋",
        sub: "Melden Sie sich in Ihrem Mopper-Bereich an.",
        email: "E-Mail",
        emailPh: "sie@unternehmen.ch",
        password: "Passwort",
        submit: "Anmelden",
        submitting: "Anmeldung…",
        success: "Erfolgreich angemeldet",
        error: "Anmeldefehler",
        noAccount: "Noch kein Konto ?",
        register: "Konto erstellen",
      },
      register: {
        badge: "Registrierung",
        title: "Erstellen Sie Ihr Konto in 30 Sekunden.",
        subTitle: "Ein einziges Konto für alle Ihre Buchungen, Rechnungen und Planungen.",
        bullets: ["Unverbindlich", "Ihre Daten in der Schweiz gespeichert", "Jederzeit kündbar"],
        heading: "Konto erstellen",
        sub: "Schliessen Sie sich über 500 aktiven Kunden an.",
        name: "Vollständiger Name",
        namePh: "Ihr Name",
        email: "E-Mail",
        emailPh: "sie@unternehmen.ch",
        phone: "Telefon (optional)",
        phonePh: "+41 79 000 00 00",
        password: "Passwort",
        passwordPh: "Mindestens 8 Zeichen",
        submit: "Mein Konto erstellen",
        submitting: "Erstellung…",
        success: "Konto erstellt. Willkommen!",
        error: "Fehler bei der Registrierung",
        pwdShort: "Das Passwort muss mindestens 8 Zeichen enthalten.",
        haveAccount: "Schon ein Konto ?",
        login: "Anmelden",
      },
      espace: {
        badge: "Kundenbereich",
        greeting: "Hallo",
        sub: "Steuern Sie Ihre nächsten Einsätze, sehen Sie Ihren Verlauf und aktualisieren Sie Ihr Profil.",
        newBooking: "Neue Buchung",
        logout: "Abmelden",
        logoutSuccess: "Bis bald !",
        tabBookings: "Meine Buchungen",
        tabProfile: "Mein Profil",
        upcoming: "Kommende",
        past: "Verlauf",
        loading: "Lädt…",
        noUpcoming: "Keine kommenden Buchungen.",
        noPast: "Noch kein Verlauf.",
        bookNow: "Jetzt buchen",
        cancel: "Stornieren",
        cancelConfirm: "Diese Buchung endgültig stornieren ?",
        cancelSuccess: "Buchung storniert",
        cancelError: "Stornierung nicht möglich",
        pricePerVisit: "Preis pro Einsatz",
        profileTitle: "Mein Profil",
        profileSub: "Diese Angaben werden zum Vorausfüllen Ihrer nächsten Buchungen verwendet.",
        profileEmail: "E-Mail",
        profileName: "Vollständiger Name",
        profilePhone: "Telefon",
        profilePostal: "PLZ",
        profileAddress: "Adresse",
        save: "Speichern",
        saving: "Speichern…",
        saveSuccess: "Profil aktualisiert",
        saveError: "Aktualisierungsfehler",
        status: { pending: "Ausstehend", confirmed: "Bestätigt", completed: "Abgeschlossen", cancelled: "Storniert" },
        frequency: { une_fois: "Einmalig", hebdomadaire: "Wöchentlich", bi_hebdo: "Alle 2 Wochen", mensuel: "Alle 4 Wochen", plus_souvent: "Häufiger" },
        reviewing: "In Prüfung",
        quoted: "Angebot gesendet",
        quoteIn24h: "Angebot in 24h",
        quoteRef: "ANGEBOT",
        particular: "Privatkunde",
        professional: "Geschäftskunde",
        serviceLabels: { move: "Umzug", transport: "Möbeltransport", clear: "Entrümpelung", declutter: "Ausräumen", organize: "Home Organizing", clean: "Reinigung", recycle: "Recycling", assembly: "Möbelmontage", full: "Komplettangebot" },
      },
    },
  },
  en: {
    nav: { services: "Services", how: "How it works", zones: "Areas", business: "Business", about: "About", help: "Help", careers: "Careers", quote: "Free quote" },
    cta: { book: "Free quote", myPrice: "Get a quote", continue: "Continue", back: "Back", submit: "Send my quote request", noCommitment: "Free quote · no commitment", whatsapp: "Send photos on WhatsApp" },
    hero: {
      title1: "Moving, clear-outs and cleaning.",
      title1Mobile: "Moving, clear-outs and cleaning.",
      dropOnMobile: "",
      title2: "",
      sub: "Mopper handles everything that clutters you.",
      trust: "Rated 5/5 on Google",
      highlight: "clear-outs",
      selectService: "Which service?",
      postalCode: "Postal code",
      reassurance: ["Professional liability (RC)", "Reliable, equipped team", "Responsible sorting & recycling"],
      pricingHint: "Free quote in 24h",
      vatIncluded: "No commitment",
    },
    services: {
      heading: "Our services",
      sub: "One single contact: clear out, transport, organize, clean, recycle.",
      move: { title: "Moving", desc: "Full or partial moves with protection, loading, transport, unloading and setup of your furniture.", tag: "Private & business", bullets: ["Furniture protection", "Local, national or international", "Disassembly/assembly optional"], price: "on quote", cta: "Get a quote" },
      clear: { title: "Clear-out", desc: "We empty cluttered spaces quickly, cleanly and with responsible handling of objects.", tag: "Apartment · cellar · garage", bullets: ["Cellar, attic, garage, home", "Sorting, removal, recycling", "Optional after-cleaning"], price: "on quote", cta: "Request a clear-out" },
      declutter: { title: "Decluttering", desc: "We help you sort, lighten and regain control of your home — without throwing everything away.", tag: "Guided sorting", bullets: ["Sort with you", "Keep, donate, recycle or discard", "Space optimization"], price: "on quote", cta: "Declutter my space" },
      organize: { title: "Home Organizing", desc: "Professional organization of your rooms, closets, dressing, kitchen, laundry or kids' bedrooms.", tag: "Interior order", bullets: ["Pretty and practical", "Storage solutions", "Sustainable everyday system"], price: "on quote", cta: "Organize my home" },
      clean: { title: "Cleaning", desc: "Cleaning after a move, after a clear-out, before handover or to restore a space.", tag: "Restoration", bullets: ["End-of-lease cleaning", "Cleaning after clear-out", "Clean, audited result"], price: "from 45 CHF/h", cta: "Book a cleaning" },
      recycle: { title: "Recycling", desc: "We sort, dispose of, and direct items to recycling, donation or revaluation whenever possible.", tag: "Responsible & sustainable", bullets: ["Sorting by material", "Disposal centers", "Donation or upcycling"], price: "included in quote", cta: "Learn more" },
      assembly: { title: "Furniture assembly", desc: "Assembly, disassembly and re-assembly of furniture before or after move, delivery or reorganization.", tag: "Assembly & disassembly", bullets: ["IKEA and other brands", "Disassembly before transport", "Re-assembly after delivery"], price: "on quote", cta: "Request an assembly" },
      transport: { title: "Furniture transport", desc: "Transport of furniture, sofas, beds, wardrobes or bulky items in Switzerland and abroad.", tag: "Switzerland & international", bullets: ["National transport", "International transport on request", "Protection and floor delivery"], price: "on quote", cta: "Request transport" },
    },
    packs: {
      heading: "Mopper Offers",
      sub: "Combined formulas so you don't have to manage anything.",
      move: { name: "Mopper Move", tag: "Moving", desc: "Everything you need for a smooth move.", items: ["Loading", "Transport", "Unloading", "Basic protection", "Furniture placement"], cta: "Quote moving" },
      clear: { name: "Mopper Clear", tag: "Clear-out", desc: "We empty, sort, dispose. You reclaim space.", items: ["Empty the space", "Sort", "Loading", "Transport", "Recycling or disposal"], cta: "Quote clear-out" },
      organize: { name: "Mopper Organize", tag: "Organize", desc: "Decluttering and home organizing for everyday life.", items: ["Sort", "Organize", "Storage optimization", "Sustainable system"], cta: "Organize my space" },
      clean: { name: "Mopper Clean", tag: "Cleaning", desc: "Restoring a home, office, or facility.", items: ["Cleaning after move", "Cleaning after clear-out", "End-of-lease cleaning", "Restoration"], cta: "Quote cleaning" },
      full: { name: "Mopper Full", tag: "Premium", featured: true, desc: "The complete offer. You delegate. We orchestrate it all.", items: ["Moving", "Clear-out", "Decluttering", "Cleaning", "Assembly", "Recycling"], cta: "Delegate everything" },
    },
    howItWorks: {
      heading: "See exactly what to expect",
      sub: "You know what you'll pay, who's coming and with what — before you commit.",
      badge: "How it works",
      timings: ["About 2\u00a0min", "Within 24\u00a0h", "On the day"],
      ctaTitle: "Ready to trust us with your project?",
      ctaSub: "A Mopper contact stays with you from quote to final wrap-up.",
      ctaButton: "Get my quote",
      ctaMicro: "About 2\u00a0minutes · Free and no commitment",
      ctaWhatsapp: "A question? WhatsApp",
      ctaTeamLabel: "Local team, reachable 7\u00a0days a week",
      zone: { heading: "Service areas", sub: "French-speaking Switzerland · national & international transport on request.", capital: "Capital" },
      steps: [
        {
          title: "You describe your need",
          desc: "Service, address, date and a few photos. No need to measure anything.",
          bullets: ["Quick, guided request", "A few photos are enough", "All your services in one place"],
        },
        {
          title: "You receive the quote",
          desc: "Fixed, itemised price, crew and vehicle included. Free, no commitment.",
          bullets: ["Reply within 24\u00a0h", "Detailed price and services", "Free quote, no commitment"],
        },
        {
          title: "We handle the job",
          desc: "Crew, gear and protections planned. Several services, one dedicated contact.",
          bullets: ["Adapted crew and gear", "Multiple services coordinated", "Simple follow-up all the way"],
        },
      ],
      example: {
        badge: "Example",
        docLabel: "Quote No. 2026-0142 · 14.06.2026",
        demandLabel: "Your request",
        service: "Moving · 3.5 rooms",
        route: "Lausanne → Morges · Sat 5 July",
        lines: [
          { label: "Crew", sub: "3 movers", amount: "CHF 680" },
          { label: "Vehicle", sub: "Van 22 m³", amount: "CHF 320" },
          { label: "Gear & protections", sub: "Blankets, straps, boxes", amount: "CHF 90" },
          { label: "Cleaning", sub: "If requested", amount: "CHF 420" },
        ],
        priceLabel: "Fixed price",
        priceValue: "CHF 1'510",
        priceNote: "Example · your quote depends on your situation",
        referent: "Your contact: Julie · reachable 7\u00a0days a week",
      },
      form: {
        title: "Your request",
        timing: "~ 2\u00a0min",
        serviceLabel: "Service",
        serviceValue: "Moving",
        housingLabel: "Home",
        housingValue: "3.5 rooms",
        dateLabel: "Preferred date",
        dateValue: "Saturday 18 July",
        photosLabel: "Photos",
        submit: "Send my request",
        toastTitle: "Request sent",
        toastSub: "Reply within 24\u00a0h",
      },
    },
    advantages: {
      heading: "Freed spaces. A simpler life.",
      sub: "A single contact to empty, move, organize, clean and recycle your spaces.",
      cta: "Request a free quote",
      combinableLabel: "Combinable services",
      combinableExamples: [
        "Moving + End-of-lease cleaning",
        "Clear-out + Handover cleaning",
        "Moving + Clear-out",
        "Clear-out + Furniture transport",
      ],
      items: [
        { title: "A single contact", desc: "One team, one quote, one follow-up. You only have one contact to coordinate everything." },
        { title: "Combinable services", desc: "Moving, clear-out, cleaning and furniture transport: we orchestrate the services you actually need." },
        { title: "Time saved", desc: "You delegate the A-to-Z logistics. We handle planning, vehicle and equipment." },
        { title: "Responsible sorting", desc: "Donation, recycling, revaluation. What can be saved is saved — the rest is cleared properly." },
        { title: "Equipped team", desc: "Vehicles, straps, protections, tools, PPE: we arrive ready to work efficiently." },
        { title: "Less stress", desc: "You explain, we execute. No more abandoned boxes, no more ruined weekends." },
      ],
      compare: {
        heading: "The result speaks for itself.",
        sub: "From chaos to clear space. We orchestrate, you breathe.",
        imgLabel: "Visible difference",
        imgValue: "Before / after Mopper.",
        beforeTitle: "Before",
        afterTitle: "After",
        before: { label: "Without Mopper", points: ["Cluttered cellar", "Stressful move", "Sorting that drags on", "Complicated handover"] },
        after: { label: "With Mopper", points: ["Freed spaces", "Orchestrated move", "Responsible sorting done", "Smooth handover"] },
      },
      img: { badge: "From chaos to clear space", statLabel: "Empty · Move · Organize", statValue: "A single contact." },
      visual: {
        config: {
          service: "Service",
          serviceVal: "Moving",
          home: "Home",
          homeVal: "3.5 rooms",
          date: "Date",
          dateVal: "Sat 14",
          status: "Request ready",
        },
        price: {
          label: "Quote ready",
          serviceVal: "Moving",
          line1: "Fixed and detailed price",
          line2: "Crew and vehicle included",
          line3: "No commitment",
        },
        done: {
          line1: "Date confirmed",
          line2: "Crew assigned",
          line3: "Intervention planned",
          daysShort: ["M", "T", "W", "T", "F", "S", "S"],
        },
      },
    },
    suiviRc: {
      badge: "The Mopper tracker",
      heading: "Your intervention, always within reach.",
      sub: "Once your quote is accepted, you receive a personal link to follow your intervention step by step. No account to create — all the important info stays available right on your phone.",
      subMobile: "A personal link to follow your intervention — no account needed.",
      benefits: [
        "No account to create",
        "Progress updated live by our team",
        "All the info in one place",
      ],
      cta: "Request a quote",
      preview: {
        greeting: "Hello Camille",
        subtitle: "Tracking your moving",
        service: "Moving",
        date: "Saturday 18 July · 09:00",
        team: "Your Mopper crew",
        currentStatus: "We have arrived",
        lastUpdate: "Last update\u00a0: a few minutes ago",
        stepsLabel: "Progress",
        steps: [
          { key: "planned", label: "Intervention confirmed", state: "done" },
          { key: "team_preparing", label: "Our crew is getting ready", state: "done" },
          { key: "team_en_route", label: "We are on the way", state: "done" },
          { key: "arrived_onsite", label: "We have arrived", state: "current" },
          { key: "completed", label: "Intervention completed", state: "upcoming" },
        ],
        helpLabel: "Need help\u00a0? Contact us",
        demoNotice: "Preview only · fictional data",
      },
      rc: {
        badge: "Insured intervention",
        heading: "Your home and belongings are protected.",
        sub: "Mopper interventions are covered by a professional liability insurance. We work with protections and gear adapted to each job to limit risks during every intervention.",
        bullets: [
          "Professional liability insurance",
          "Protections adapted to the intervention",
          "Crew and gear prepared in advance",
        ],
        coverageLabelTemplate: "Professional liability up to CHF\u00a0{amount}\u00a0million",
      },
    },
    _purged_EN_block: {
      _note: "Old EN cleaning-only blocks removed during multi-service migration."
    },
    socialProof: {
      heading: "500+ businesses trust Mopper",
      sub: "Verified reviews from real customers.",
      badge: "4.9/5 average across 1,284 reviews",
      testimonials: [
        { name: "Claire R.", role: "Office manager, Lausanne", text: "Since we switched to Mopper I’ve stopped thinking about cleaning. It’s always spotless on Monday mornings." },
        { name: "Julien B.", role: "Restaurant owner, Geneva", text: "Punctual team, gentle products, simple invoicing. Highly recommend." },
        { name: "Sarah M.", role: "Medical practice director", text: "A dedicated operator who knows our space. Consistency makes all the difference." },
      ],
    },
    faqShort: {
      heading: "Frequently asked",
      sub: "Everything to know before booking.",
      items: [
        { q: "How does booking work ?", a: "2 minutes: pick your service, frequency and options, confirm. We reach out within 24h." },
        { q: "Can I change my hours ?", a: "Yes, anytime. No commitment at all." },
        { q: "Who comes on site ?", a: "A dedicated, trained and vetted operator — always the same person." },
        { q: "Do you use harsh products ?", a: "No. We use certified eco-friendly products and offer steam cleaning where possible." },
        { q: "Can I request a quote ?", a: "Absolutely. Use the configurator or contact us — reply within the day." },
      ],
      cta: "See all questions",
    },
    ctaFinal: {
      heading: "You have nothing to manage.",
      heading2: "Mopper handles everything.",
      reassure: "Free quote within 24h · No commitment · Fast intervention",
      primary: "Request a free quote",
      secondary: "Send my photos on WhatsApp",
    },
    team: {
      badge: "People first",
      heading: "Trained teams.",
      heading2: "Protected belongings. Respected spaces.",
      sub: "Protection of your belongings, respect for your spaces, suitable equipment and human follow-up — from the first box to the final polish.",
      trust: [
        { label: "In-house team, no subcontracting" },
        { label: "Floor, wall and furniture protections" },
        { label: "A reachable contact at every step" },
      ],
      items: [
        { title: "Trained team", desc: "Handling, protection, methods: our crew is trained for every type of intervention — from moving to end-of-lease cleaning." },
        { title: "Suitable equipment", desc: "Vehicles, straps, blankets, dollies, tools, PPE. We arrive with everything needed to work fast and well." },
        { title: "Protected belongings", desc: "Your furniture and fragile items are protected, packed and handled with care — and every intervention is covered by our professional liability insurance (RC)." },
        { title: "Responsible sorting", desc: "Donation, recycling, revaluation: we favour a second life over the dump whenever possible." },
        { title: "Human follow-up", desc: "A reachable Mopper lead, regular check-ins, real dialogue. You always know where we stand." },
        { title: "Respect for spaces", desc: "Floor protections, walls protected, cleanliness on departure. We leave the space the way we'd want to find it." },
      ],
    },
    footer: {
      tagline: "Moving, clear-out, organizing and cleaning in Switzerland. Mopper takes care of everything cluttering your life.",
      col1: "Company",
      col2: "Resources",
      col3: "Contact",
      rights: "© 2026 Mopper. All rights reserved.",
    },
    booking: {
      progress: "Step",
      steps: ["Service", "Details", "Contact", "Summary"],
      stepService: {
        heading: "Which service do you need?",
        sub: "Pick one or several services. Everything can be combined in one quote.",
        options: { move: "Moving", clear: "Clear-out", declutter: "Decluttering", organize: "Home Organizing", clean: "Cleaning", recycle: "Recycling", assembly: "Furniture assembly", transport: "Furniture transport", full: "Full package" },
      },
      stepDetails: {
        heading: "Details of your request",
        message: "Describe your needs",
        messagePh: "Space type, estimated volume, constraints (floors, lift), photos on WhatsApp possible…",
        addressFrom: "Pick-up address", addressTo: "Drop-off address", address: "Intervention address", date: "Preferred date",
        rooms: "Number of rooms", volume: "Estimated volume (m³)", floorFrom: "Floor (from)", floorTo: "Floor (to)", floor: "Floor",
        liftFrom: "Lift (from)", liftTo: "Lift (to)", lift: "Lift", spaceType: "Space type",
        heavyItems: "Heavy items (piano, safe…)", cleanAfter: "Cleaning after clear-out",
        boxes: "Need boxes", disassembly: "Disassembly / reassembly", finalCleaning: "End-of-lease cleaning", cleanType: "Cleaning type",
        surface: "Surface (m²)", windows: "Windows included", appliances: "Appliances included",
        itemDescription: "Item to transport", dimensions: "Approximate dimensions", yes: "Yes", no: "No",
      },
      step1: { heading: "What type of space would you like cleaned?", options: { bureau: "Office", commerce: "Retail", restaurant: "Restaurant", cabinet: "Practice", fitness: "Fitness" } },
      step1Home: { heading: "What type of home?", options: { appartement: "Apartment", maison: "House", studio: "Studio" } },
      stepSize: { heading: "How big is the home?", hint: "We dispatch 1-3 operators depending on size." },
      step2: { heading: "How many hours per visit?", hint: "2 hour minimum per visit." },
      step3: { heading: "How often?", options: { une_fois: "One-off", hebdomadaire: "Weekly", bi_hebdo: "Every 2 weeks", mensuel: "Every 4 weeks", plus_souvent: "More often" } },
      step4: { heading: "Add options", hint: "Each option automatically adds time." },
      step5: { heading: "Your quote", totalTime: "Total time", perPass: "Price per visit", monthly: "Monthly estimate", ht: "Net", ttc: "Gross", vat: "VAT 8.1%", hourly: "Hourly rate incl. VAT" },
      step6: { heading: "Your contact details", name: "Full name", email: "Email", phone: "Phone", address: "Intervention address", postal: "Postal code", date: "Preferred date", notes: "Notes (optional)" },
      summary: { heading: "Summary of your request", service: "Service(s) requested", details: "Details", contact: "Contact", send: "Send my quote request", sending: "Sending…" },
      thankYou: { heading: "Thank you! Your request is in.", body: "A confirmation email has been sent. We'll get back to you with a quote within 24h." },
    },
    about: {
      heading: "About Mopper",
      sub: "Mopper is a Swiss multi-service company born from a simple idea: making life's complicated moments easier.",
      intro: "Moving, clear-out, end-of-lease cleaning or furniture transport: we help individuals and businesses regain clear, clean and functional spaces.",
      sections: [
        { title: "Our mission", body: "Free individuals and businesses from the mental load of cluttered spaces. One single contact to empty, transport, organize, clean and recycle." },
        { title: "Our method", body: "Clear quote, trained team, pro equipment, asset protection, responsible sorting. Every intervention is structured, documented, and executed with care." },
        { title: "Our commitments", body: "Price transparency, on-time delivery, cleanliness at handover, responsible sorting of items and materials. We promise what we keep." },
        { title: "Our ecological vision", body: "Donation, recycling and revalorization come first. We avoid landfill by directing items to the right channels: charity, sorting centers, resale." },
        { title: "Our services", body: "Moving, clear-out, end-of-lease cleaning and furniture transport in French-speaking Switzerland." },
      ],
    },
    help: {
      heading: "Help center",
      sub: "Answers to frequent questions.",
      faq: [
        { q: "Which services does Mopper offer?", a: "Moving, clear-out, end-of-lease cleaning and furniture transport in French-speaking Switzerland." },
        { q: "Can I combine moving, clear-out and cleaning?", a: "Yes, and it's actually our strength. You describe your situation, we build a combined offer covering everything." },
        { q: "How do I get a quote?", a: "Via the 2-minute quote form. You can also send us photos on WhatsApp to speed up estimation." },
        { q: "Should I send photos?", a: "Not mandatory but highly recommended: it lets us estimate volume, access and required equipment more accurately." },
        { q: "Do you intervene in emergencies?", a: "Yes, subject to availability. Indicate the urgency in your request, we'll get back to you within hours." },
        { q: "Do you do international transport?", a: "Yes, furniture transport or moves to France, Italy, Germany and beyond. Tailored quote." },
        { q: "What do you do with collected items?", a: "Responsible sorting: donation (charities), material recycling, revalorization when possible. Landfill is our last resort." },
        { q: "Are landfill fees included?", a: "Included in most cases (depending on volume and nature). If exceeded, it's clearly stated in the quote." },
        { q: "Can you disassemble and reassemble my furniture?", a: "Yes, assembly / disassembly / reassembly for IKEA and other brands. Available as an option in the quote." },
        { q: "Do you do end-of-lease cleaning?", a: "Yes, with property-manager guarantee. Deep cleaning and presence at handover possible." },
        { q: "Do you serve businesses?", a: "Yes, offices, commercial spaces, restaurants, practices. Moving, clear-out, cleaning, assembly." },
        { q: "Which areas do you cover?", a: "All of French-speaking Switzerland (Vaud, Geneva, Fribourg, Neuchâtel, Jura, Valais). National and international transport on request." },
        { q: "How does payment work?", a: "Invoice after intervention, payment by bank transfer or TWINT. VAT explicitly stated in the quote." },
        { q: "I need to empty a basement in Lausanne, do you cover it?", a: "Yes, basement clear-out in Lausanne and the canton of Vaud. Responsible sorting, recycling, removal included. Quote within 24h." },
        { q: "I'm handing back my apartment, can you handle everything?", a: "Yes, that's our specialty. Clear-out of leftover items, end-of-lease cleaning with handover guarantee, attendance at handover possible. One single contact." },
        { q: "I need to clear out a property after a death, how does it work?", a: "With great discretion and respect. We take time to identify valuables and important papers before any sorting. Family and notaries supported step by step." },
        { q: "I need to transport a sofa bought online, can you do it?", a: "Yes, single-item or batch furniture transport in Lausanne, Geneva and throughout Switzerland. Disassembly/reassembly possible at both ends." },
        { q: "Does Mopper assemble IKEA furniture?", a: "Yes, assembly of all IKEA furniture (Pax, Malm, Hemnes, Billy, full wardrobes). Equipped team, transparent pricing, fast intervention in Lausanne and Geneva." },
        { q: "I want to delegate everything, what should I do?", a: "Send us a few photos on WhatsApp (+41 78 232 18 50) or fill in the online form. We send you a quote within 24h, you approve, we handle everything." },
      ],
    },
    careers: {
      heading: "Join Mopper",
      sub: "Join a modern company that simplifies people's lives and transforms their spaces.",
      cta: "Apply",
      roles: [
        { title: "Mover · handler", type: "Permanent / Fixed-term · French-speaking Switzerland", desc: "Loading, transport, protection and installation of furniture at clients' homes." },
        { title: "Clear-out operator", type: "Permanent / Fixed-term · French-speaking Switzerland", desc: "Emptying, sorting, responsible removal of apartments, basements, garages, premises." },
        { title: "Cleaning operator", type: "Permanent / Part- or full-time", desc: "Cleaning after moves, after clear-outs, end-of-lease. Team or pair work." },
        { title: "Furniture assembler", type: "Permanent / Fixed-term · Lausanne · Geneva", desc: "Assembly, disassembly and reassembly of IKEA and other brands at clients' homes." },
        { title: "Team Leader", type: "Permanent · French-speaking Switzerland", desc: "Operational management of a field team. Planning, quality, customer relations." },
        { title: "Operations coordinator", type: "Permanent · Lausanne", desc: "Schedule management, quotes, interventions and customer follow-up." },
      ],
    },
    admin: {
      login: { heading: "Mopper Admin", label: "Password", button: "Log in", error: "Incorrect password" },
      dashboard: { heading: "Bookings", empty: "No bookings yet.", logout: "Log out" },
    },
    auth: {
      header: { login: "Log in", account: "My account", loginRegister: "Log in / Sign up" },
      login: {
        badge: "Customer area",
        title: "Run your cleanings from your dashboard.",
        subTitle: "History, invoices, schedule, booking changes — all in a few clicks.",
        heading: "Welcome back 👋",
        sub: "Log in to your Mopper area.",
        email: "Email",
        emailPh: "you@company.ch",
        password: "Password",
        submit: "Log in",
        submitting: "Signing in…",
        success: "Successfully logged in",
        error: "Login error",
        noAccount: "No account yet ?",
        register: "Create an account",
      },
      register: {
        badge: "Sign up",
        title: "Create your account in 30 seconds.",
        subTitle: "One account to manage your bookings, invoices and schedule.",
        bullets: ["No commitment", "Data stored in Switzerland", "Cancel anytime"],
        heading: "Create an account",
        sub: "Join 500+ active customers.",
        name: "Full name",
        namePh: "Your name",
        email: "Email",
        emailPh: "you@company.ch",
        phone: "Phone (optional)",
        phonePh: "+41 79 000 00 00",
        password: "Password",
        passwordPh: "Minimum 8 characters",
        submit: "Create my account",
        submitting: "Creating…",
        success: "Account created. Welcome!",
        error: "Sign-up error",
        pwdShort: "Password must contain at least 8 characters.",
        haveAccount: "Already have an account ?",
        login: "Log in",
      },
      espace: {
        badge: "Customer area",
        greeting: "Hello",
        sub: "Run your upcoming visits, browse your history and update your profile.",
        newBooking: "New booking",
        logout: "Log out",
        logoutSuccess: "See you soon !",
        tabBookings: "My bookings",
        tabProfile: "My profile",
        upcoming: "Upcoming",
        past: "History",
        loading: "Loading…",
        noUpcoming: "No upcoming bookings.",
        noPast: "No history yet.",
        bookNow: "Book now",
        cancel: "Cancel",
        cancelConfirm: "Cancel this booking permanently ?",
        cancelSuccess: "Booking cancelled",
        cancelError: "Cancellation failed",
        pricePerVisit: "Price per visit",
        profileTitle: "My profile",
        profileSub: "These details will pre-fill your next bookings.",
        profileEmail: "Email",
        profileName: "Full name",
        profilePhone: "Phone",
        profilePostal: "Postal code",
        profileAddress: "Address",
        save: "Save",
        saving: "Saving…",
        saveSuccess: "Profile updated",
        saveError: "Update error",
        status: { pending: "Pending", confirmed: "Confirmed", completed: "Completed", cancelled: "Cancelled" },
        frequency: { une_fois: "One-off", hebdomadaire: "Weekly", bi_hebdo: "Every 2 weeks", mensuel: "Every 4 weeks", plus_souvent: "More often" },
        reviewing: "Under review",
        quoted: "Quote sent",
        quoteIn24h: "Quote within 24h",
        quoteRef: "QUOTE",
        particular: "Residential",
        professional: "Professional",
        serviceLabels: { move: "Removals", transport: "Furniture transport", clear: "Clear-out", declutter: "Decluttering", organize: "Home organizing", clean: "Cleaning", recycle: "Recycling", assembly: "Furniture assembly", full: "Full service" },
      },
    },
  },
};

const I18nContext = createContext({ lang: "fr", t: dict.fr, setLang: () => {} });

export const SUPPORTED_LANGS = ["fr", "de", "en"];

// Detect active language from the URL prefix (/de/… , /en/… , else FR at root).
export function detectLangFromPath(pathname) {
  const seg = (pathname || "/").split("/")[1];
  return seg === "de" || seg === "en" ? seg : "fr";
}

// Router basename for a language: "/" for FR (root), "/de" / "/en" otherwise.
export function langBasename(lang) {
  return lang === "fr" ? "/" : `/${lang}`;
}

// Strip any language prefix from a full pathname → bare app path ("/tarifs").
export function stripLangPrefix(pathname) {
  const seg = (pathname || "/").split("/")[1];
  if (seg === "de" || seg === "en") {
    const rest = pathname.slice(3);
    return rest === "" ? "/" : rest;
  }
  return pathname || "/";
}

export function I18nProvider({ children }) {
  const [lang] = useState(() => detectLangFromPath(window.location.pathname));
  useEffect(() => {
    document.documentElement.lang = lang;
    try { localStorage.setItem("mopper_lang", lang); } catch (e) {}
  }, [lang]);
  // Switching language changes the URL (required for indexable multilingual SEO):
  // a full navigation reboots the app under the new /de|/en basename, so every
  // internal <Link> is automatically re-prefixed via BrowserRouter basename.
  const setLang = (code) => {
    if (code === lang || !SUPPORTED_LANGS.includes(code)) return;
    const bare = stripLangPrefix(window.location.pathname);
    const prefix = code === "fr" ? "" : `/${code}`;
    let target = prefix + bare;
    if (target.length > 1) target = target.replace(/\/+$/, "");
    if (!target) target = "/";
    window.location.assign(target + window.location.search + window.location.hash);
  };
  const t = dict[lang] || dict.fr;
  return <I18nContext.Provider value={{ lang, t, setLang }}>{children}</I18nContext.Provider>;
}

export function useI18n() { return useContext(I18nContext); }

export const LANGS = [
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
];
;
